<template>
  <div>
    <div class="header-wrapper">
      <div class="header-container">
        <div class="logo-container">
          <router-link :to="{ name: 'home' }">
            <img
              class="bunicorn-logo"
              src="@/assets/logo/logo.png"
              alt="bunicorn logo"
            />
          </router-link>
        </div>

        <template v-if="windowWidth < 1068">
          <div class="wallet-noti-wrapper">
            <div class="route-item">
              <div
                v-if="wrongNetwork"
                class="address"
                @click="toggleChooseWallet(true)"
              >
                Wrong Network
              </div>
              <img
                v-else-if="!isConnected"
                src="@/assets/icon/wallet-icon.svg"
                @click="toggleChooseWallet(true)"
              />

              <div v-else class="address" @click="toggleMyWallet(true)">
                {{ sliceAddress(address, 4) }}
              </div>
            </div>
            <!--            <div class="route-item">-->
            <!--              <img-->
            <!--                src="@/assets/icon/notification-icon.svg"-->
            <!--                @click="toggleMyNotification(true)"-->
            <!--              >-->
            <!--            </div>-->
            <img
              v-b-toggle.my-collapse
              class="menu-icon"
              src="@/assets/icon/mobile/menu-icon.png"
            />
          </div>
        </template>
        <template v-else>
          <div class="menu-wrapper">
            <div class="route-item">
              <router-link :to="{ name: 'market-bunicorn-game' }" exact>
                Gaming Marketplace
              </router-link>
            </div>
            <div class="route-item">
              <router-link :to="{ name: 'artwork-market' }" exact>
                Artwork Marketplace
              </router-link>
            </div>
            <!--            <div class="route-item">-->
            <!--              <router-link :to="{ name: 'mystery-box' }">-->
            <!--                Mystery Boxes-->
            <!--              </router-link>-->
            <!--            </div>-->
            <div v-if="myAccount" class="route-item">
              <router-link :to="{ name: 'my-collection' }">
                My Collection
              </router-link>
            </div>
            <div v-if="myAccount" class="route-item">
              <router-link :to="{ name: 'create' }">
                Create
              </router-link>
            </div>
          </div>
          <div class="wallet-noti-wrapper">
            <div class="route-item">
              <div
                v-if="wrongNetwork"
                class="address"
                @click="toggleChooseWallet(true)"
              >
                Wrong Network
              </div>
              <img
                v-else-if="!isConnected"
                src="@/assets/icon/wallet-icon.svg"
                @click="toggleChooseWallet(true)"
              />
              <div v-else class="address" @click="toggleMyWallet(true)">
                {{ sliceAddress(address, 4) }}
              </div>
            </div>
            <!--            <div class="route-item">-->
            <!--              <img-->
            <!--                src="@/assets/icon/notification-icon.svg"-->
            <!--                @click="toggleMyNotification(true)"-->
            <!--              >-->
            <!--            </div>-->
          </div>
          <!-- <div class="icon-header">
            <div class="connect-wallet-btn" @click="handleConnectWallet()">
              <template v-if="!!address">
                {{ sliceAddress(address, 7) }}
              </template>
              <template v-else>
                <img src="@/assets/icon/wallet.png" alt="white wallet icon" />
              </template>
            </div>
            <div class="notification" @click="toggleMyNotification(true)">
              <img
                src="@/assets/icon/notification.png"
                alt="notification icon"
                class="notification-icon"
              />
              <img
                src="@/assets/icon/notification-dot.png"
                alt="notification icon"
                class="notification-dot"
              />
            </div>
          </div> -->
        </template>
        <b-collapse id="my-collapse">
          <div class="mobile-nav">
            <router-link :to="{ name: 'market-bunicorn-game' }" exact>
              Gaming Marketplace
            </router-link>
            <router-link :to="{ name: 'artwork-market' }" exact>
              Artwork Marketplace
            </router-link>
            <!--            <router-link-->
            <!--              :to="{ name: 'mystery-box' }"-->
            <!--              exact-->
            <!--            >-->
            <!--              Mystery Boxes-->
            <!--            </router-link>-->
            <router-link v-if="myAccount" :to="{ name: 'my-collection' }">
              My Collection
            </router-link>
            <router-link v-if="myAccount" :to="{ name: 'create' }" exact>
              Create
            </router-link>
            <!-- <router-link
              :to="{ name: 'resources' }"
              exact
            >
              Resources
            </router-link> -->
            <!-- <router-link
              :to="{ name: 'profile' }"
              exact
            >
              Profile
            </router-link> -->
          </div>
        </b-collapse>
      </div>
    </div>

    <BaseCustomModal
      v-if="isShowChooseWallet"
      :is-corner="true"
      @closeModal="toggleChooseWallet(false)"
    >
      <choose-wallet @close-choose-wallet-modal="toggleChooseWallet(false)" />
    </BaseCustomModal>
    <BaseCustomModal
      v-if="isShowMyWallet"
      :is-corner="true"
      @closeModal="toggleMyWallet(false)"
    >
      <MyWallet @closeModal="toggleMyWallet(false)" />
    </BaseCustomModal>
    <!-- <BaseCustomeModal v-if="isWrongNetwork" :isHideClose="true">
      <WrongNetwork />
    </BaseCustomeModal> -->
    <BaseCustomModal
      v-if="isNotifation"
      :is-corner="true"
      @closeModal="toggleMyNotification(false)"
    >
      <Notificaion />
    </BaseCustomModal>
  </div>
</template>

<script>
import BaseCustomModal from '@/components/BaseCustomModal.vue';
import { mapState } from 'vuex';
import { ChooseWallet, MyWallet, Notificaion } from '@/modal';

export default {
  components: {
    //  BaseModal,
    ChooseWallet,
    // WrongNetwork,
    Notificaion,
    MyWallet,
    BaseCustomModal
  },
  data() {
    return {
      isShowChooseWallet: false,
      isShowMyWallet: false,
      isNotifation: false,
      windowWidth: window.innerWidth,
      resizeEvent: null
    };
  },
  computed: {
    ...mapState('auth', ['address', 'wrongNetwork']),
    //   ...mapState(["isWrongNetwork"]),
    isConnected() {
      return !!this.address;
    },
    myAccount() {
      return this.$store.state.auth.address;
    }
  },
  mounted() {
    this.resizeEvent = window.addEventListener('resizeWindow', () => {
      this.windowWidth = window.innerWidth;
    });
  },
  beforeUnmount() {
    window.removeEventListener('resizeWindow', this.resizeEvent);
  },
  // watch: {
  //   isConnected() {
  //     if (!this.isConnected) {
  //       return;
  //     }
  //     this.isShowChooseWallet = false;
  //   },
  // },
  methods: {
    toggleChooseWallet(isShow) {
      this.isShowChooseWallet = isShow;
    },
    toggleMyWallet(isShow) {
      this.isShowMyWallet = isShow;
    },
    toggleMyNotification(isShow) {
      this.isNotifation = isShow;
    },
    handleConnectWallet() {
      if (this.isConnected) {
        this.toggleMyWallet(true);
        return;
      }
      this.toggleChooseWallet(true);
    },
    sliceAddress(address, numberSlice) {
      return (
        address.slice(0, numberSlice) +
        '...' +
        address.slice(address.length - numberSlice, address.length)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import './../assets/style/variables.scss';

.header-wrapper {
  display: flex;
  justify-content: center;
  padding: 8px 0;
  background: #ffffff;
  box-shadow: 0px 4px 32px rgba(52, 87, 210, 0.08);

  .header-container {
    width: 90%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .address {
      padding: 4px 16px;
      color: #828c9f;
      border-radius: 4px;
      border: 1px solid #828c9f;
      font-size: 13px;
    }
    .menu-icon {
      width: 25px;
      height: 25px;
    }
    .logo-container {
      display: flex;
      align-items: center;
      width: 192px;
      .arena-logo {
        margin-left: 30px;
      }
    }
    .wallet-noti-wrapper,
    .menu-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .route-item {
      position: relative;
      cursor: pointer;
      font-size: 16px;
      margin: 0 10px;
      font-family: Inter-Medium;
      a {
        color: #828c9f;
        text-decoration: none;
        &:hover {
          color: #5b6ef5;
        }
      }
      .router-link-active {
        color: #5b6ef5;
      }
    }
  }
  .icon-header {
    display: flex;
    .connect-wallet-btn {
      cursor: pointer;
      padding: 10px 10px;
      border-radius: 6px;
      img {
        margin-right: 5px;
        width: 22px;
        object-fit: contain;
        opacity: 0.6;
      }
      &:hover {
        box-shadow: 0px 0px 5px 4px rgba(168, 168, 168, 0.25);
        -webkit-box-shadow: 0px 0px 5px 4px rgba(168, 168, 168, 0.25);
        -moz-box-shadow: 0px 0px 5px 4px rgba(168, 168, 168, 0.25);
      }
    }
    .notification {
      position: relative;
      cursor: pointer;
      padding: 10px 10px;
      border-radius: 6px;
      .notification-icon {
        margin-right: 5px;
        width: 22px;
        object-fit: contain;
      }
      .notification-dot {
        position: absolute;
        width: 12px;
        object-fit: contain;
        top: 8px;
        right: 15px;
      }
      &:hover {
        box-shadow: 0px 0px 5px 4px rgba(168, 168, 168, 0.25);
        -webkit-box-shadow: 0px 0px 5px 4px rgba(168, 168, 168, 0.25);
        -moz-box-shadow: 0px 0px 5px 4px rgba(168, 168, 168, 0.25);
      }
    }
  }
}

@media (max-width: $breakpoint-desktop) {
  .header-wrapper {
    padding: 0;
    .header-container {
      width: 100%;
      padding-top: 16px;
      padding-bottom: 8px;
      flex-wrap: wrap;
      #my-collapse {
        width: 100%;
        margin-top: 16px;
      }
      .mobile-nav {
        width: 100%;
        display: flex;
        flex-direction: column;
        a {
          padding: 8px 16px;
          width: 100%;
          color: #000;
          cursor: pointer;
          &:hover {
            background-color: rgba(168, 168, 168, 0.25);
            text-decoration: none;
          }
        }
        .router-link-active {
          color: #5b6ef5;
        }
      }
      .logo-container {
        margin-left: 10px;
        .bunicorn-logo {
          height: 40px;
        }
      }
      .control-container {
        justify-content: flex-end;
        .route-item {
          margin: 4px 20px;
        }
      }
      .menu-icon {
        margin-right: 10px;
      }
    }
  }
}

.bunicorn-logo {
  height: 50px;
}
@media (max-width: $breakpoint-mobile) {
  .header-wrapper {
    .header-container {
      .logo-container {
        height: 40px;
        width: fit-content;
      }
    }
  }
}
</style>
